import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="footer" className="bg-moebus-deep text-white relative overflow-hidden">
            <div className="absolute inset-0 grid-pattern opacity-10"></div>

            <div className="relative container mx-auto px-4 md:px-8 py-16 md:py-20">
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
                    <div className="lg:col-span-2">
                        <div className="flex items-center gap-4 mb-6">
                            <img
                                src="https://customer-assets.emergentagent.com/job_moebus-karriere/artifacts/15h4op5x_moebus_logo_fuer_wwww_kl%20Final%20Done-2.svg"
                                alt="Möbus Umweltschutz GmbH"
                                className="h-16 w-auto object-contain"
                            />
                            <div>
                                <div className="font-heading font-bold text-lg">Möbus Umweltschutz GmbH</div>
                                <div className="text-xs uppercase tracking-widest text-emerald-400 mt-0.5">
                                    Umwelttechnik · Wasser · Anlagenbau
                                </div>
                            </div>
                        </div>
                        <p className="text-sm text-slate-300 max-w-md leading-relaxed">
                            Wir liefern, montieren und betreuen technische Lösungen rund um Wasser, Umwelt und
                            Baustelleninfrastruktur – deutschlandweit und darüber hinaus.
                        </p>
                    </div>

                    <div>
                        <div className="text-xs font-semibold uppercase tracking-widest text-emerald-400 mb-4">
                            Kontakt
                        </div>
                        <ul className="space-y-3 text-sm text-slate-300">
                            <li className="flex gap-3">
                                <MapPin size={16} className="text-slate-400 mt-0.5 flex-shrink-0" />
                                <span>
                                    Andreas-Schubert-Str. 01
                                    <br />
                                    01844 Neustadt
                                </span>
                            </li>
                            <li className="flex gap-3">
                                <Phone size={16} className="text-slate-400 mt-0.5 flex-shrink-0" />
                                <a
                                    href="tel:+4935965592990"
                                    className="hover:text-emerald-400 transition-colors"
                                >
                                    +49 (0) 3596 5592990
                                </a>
                            </li>
                            <li className="flex gap-3">
                                <Mail size={16} className="text-slate-400 mt-0.5 flex-shrink-0" />
                                <a
                                    href="mailto:info@moebus-umweltschutz.de"
                                    className="hover:text-emerald-400 transition-colors break-all"
                                >
                                    info@moebus-umweltschutz.de
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <div className="text-xs font-semibold uppercase tracking-widest text-emerald-400 mb-4">
                            Rechtliches
                        </div>
                        <ul className="space-y-3 text-sm text-slate-300">
                            <li>
                                <Link to="/impressum" className="hover:text-emerald-400 transition-colors">
                                    Impressum
                                </Link>
                            </li>
                            <li>
                                <Link to="/datenschutz" className="hover:text-emerald-400 transition-colors">
                                    Datenschutz
                                </Link>
                            </li>
                            <li>
                                <Link to="/kontakt" className="hover:text-emerald-400 transition-colors">
                                    Kontakt
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/admin"
                                    data-testid="admin-link"
                                    className="hover:text-emerald-400 transition-colors opacity-70"
                                >
                                    Admin-Bereich
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-slate-400">
                    <div>© {new Date().getFullYear()} Möbus Umweltschutz GmbH. Alle Rechte vorbehalten.</div>
                    <div className="tracking-widest uppercase">Karriere-Portal</div>
                </div>
            </div>
        </footer>
    );
}
